export const ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE = 'data-annotation-focus-fallback';

/** Marks a surface's annotation toggle: where focus goes once the control holding it is gone. */
export const ANNOTATION_FOCUS_FALLBACK_PROPS = {[ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE]: ''} as const;

export function focusAnnotationFallbackIfLost(): void {
  if (!document.activeElement || document.activeElement === document.body) {
    document.querySelector<HTMLElement>(`[${ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE}]`)?.focus();
  }
}
